import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "qrcode" }
const _hoisted_2 = { class: "qrcode-toolbar" }

import { useApi } from '@/hooks/useApi';
import {
  useBaseAsync,
  type HpsfirProFormItem,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
} from 'hpsfir-managebase-ui';

import { keyBy } from 'lodash';
import { ref } from 'vue';
import QrcodeVue from 'qrcode.vue';
import { ElMessage } from 'element-plus';
import { convertBase64UrlToImgFile } from '@/utils';
import { normalizeBizTableColumns } from '@/utils/tableColumns';

interface QrcodeRow {
  name: string;
  appid?: string;
  h5TplId?: string;
  url: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'qrcode',
  emits: ["setDownload"],
  setup(__props, { expose: __expose, emit: __emit }) {

const addWeappFormRef = ref<any>();
const addWeappItems = ref<HpsfirProFormItem[]>([]);
const addH5FormRef = ref<any>();
const addH5Items = ref<HpsfirProFormItem[]>([]);
const tableRef = ref<any>();
const deleteQrcodeDialogRef = ref<any>();
const emit = __emit;
const store = ref<any>({});

const qrcodeDialogVisible = ref(false);

// 获取的二维码值
const qrcodeValues = ref<QrcodeRow[]>([]);

const loading = ref(false);

const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([
  {
    name: 'name',
    label: '名称',
    type: 'string',
    width: 180,
  },
  {
    name: 'url',
    label: '二维码',
    type: 'string',
    width: 180,
    render: (scope: any) => {
      const row = scope?.row as QrcodeRow | undefined;
      if (!row?.url) {
        return '';
      }
      return (
        <QrcodeVue
          id={`qrcode-${scope.$index}`}
          value={row.url}
          size={800}
          style="width: 100px; height: 100px"
        />
      );
    },
  },
  {
    name: 'downloadQrcodeUrl',
    label: '客户端下载',
    type: 'string',
    render: (scope: any) => (store.value.downloadQrcodeUrl === scope?.row?.url ? '是' : ''),
  },
]));

const saveQrcode = (qrcode: QrcodeRow, inx: any) => {
  const qrcodeEl: any = document.getElementById(`qrcode-${inx}`);
  if (!qrcodeEl) {
    return;
  }
  const dataURL = qrcodeEl.toDataURL('image/png');

  const link = document.createElement('a');
  link.href = dataURL;
  link.download = `qrcode-${qrcode.name}.png`;
  link.style.display = 'none';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const getData = useBaseAsync<HpsfirProTableGetDataFunction>((filter: HpsfirProTableFilter) => {
  const page = filter.paginations.page || 1;
  const pageSize = filter.paginations.pageSize || 10;
  const start = (page - 1) * pageSize;
  const data = qrcodeValues.value.slice(start, start + pageSize);
  return {
    total: qrcodeValues.value.length,
    data,
  } as HpsfirProTableData;
});

const init = useBaseAsync(async() => {
  try {
    loading.value = true;
    qrcodeValues.value = [];
    // 获取小程序列表
    const weappRes = await useApi().wxApi.getRelativeWeappwx({ appid: store.value.wxAppid });
    const weappOptions = weappRes?.data?.data?.filter((item: any) => item.status === 1).map((item: any) => ({
      label: item.nickname,
      value: item.appid,
    }));
    // 获取h5模板列表
    const h5TplRes = await useApi().wxTplApi.listWxTplByTenantwxTpl({ });
    const h5TplOptions = h5TplRes?.data?.data?.map((item: any) => ({
      label: `${item.name}(${item.url})`,
      value: item.id,
    }));

    addWeappItems.value = [
      {
        name: 'appid',
        label: '小程序',
        type: 'select',
        rule: [{ required: true }],
        options: weappOptions,
      },
    ];

    addH5Items.value = [
      {
        name: 'id',
        label: 'H5模板',
        type: 'select',
        rule: [{ required: true }],
        options: h5TplOptions,
      },
    ];

    const weappMap = keyBy(weappOptions as any, (item) => String(item.value));
    const res = await useApi().storeApi.getQrcodesstore({
      storeId: store.value.id,
    });
    Object.entries(res?.data?.data?.weappQrcode || {}).forEach(([appid, url]: any) => {
      const weapp = weappMap[appid];
      if (!weapp) {
        return;
      }
      qrcodeValues.value.push({
        name: `${weapp.label}(小程序)`,
        appid,
        url,
      });
    });

    const h5Map = keyBy(h5TplOptions as any, (item) => item.value);
    Object.entries(res?.data?.data?.wxQrcode || {}).forEach(([h5TplId, url]: any) => {
      const h5Tpl = h5Map[String(h5TplId)];
      if (!h5Tpl) {
        return;
      }
      qrcodeValues.value.push({
        name: `${h5Tpl.label}`,
        h5TplId: String(h5TplId),
        url,
      });
    });

    if (res?.data?.data?.directQrcodeUrl) {
      qrcodeValues.value.push({
        name: '直开',
        url: res?.data?.data?.directQrcodeUrl,
      });
    }
    store.value.downloadQrcodeUrl = res.data.data.downloadQrcodeUrl ? res.data.data.downloadQrcodeUrl.split('_#_#_')[0] : '';
    tableRef.value?.refresh?.();
  } finally {
    loading.value = false;
  }
});

const setDownloadQrcode = useBaseAsync(async(qrcode: QrcodeRow, inx: any) => {
  const qrcodeEl: any = document.getElementById(`qrcode-${inx}`);
  if (!qrcodeEl) {
    return;
  }
  const dataURL = qrcodeEl.toDataURL('image/png');
  try {
    const res = await useApi().uploadApi.imageUpload([convertBase64UrlToImgFile(dataURL, 'qrcode.png').file]);

    if (!res.data.data?.[0]) {
      ElMessage.error('设置失败！');
      return;
    }

    await useApi().storeApi.setDownloadQrcodestore({
      storeId: store.value.id,
      qrcodeUrl: `${qrcode.url}_#_#_${res.data.data?.[0]}`,
    });
    init();
    emit('setDownload');
  } catch (error) {
    console.log(error);
  }
});

const handleaddWeappOk = useBaseAsync(async(data: any) => {
  await useApi().storeApi.addWeappQrcodestore({
    storeId: store.value.id,
    appid: data.appid,
  });
  ElMessage.success('添加成功');
  init();
});

const handleaddH5Ok = useBaseAsync(async(data: any) => {
  await useApi().storeApi.addH5Qrcodestore({
    storeId: store.value.id,
    h5TplId: data.id,
  });
  ElMessage.success('添加成功');
  init();
});

const handleAddDirectQrcode = useBaseAsync(async() => {
  await useApi().storeApi.addDirectQrcodeUrlstore({
    storeId: store.value.id,
  });
  ElMessage.success('添加成功');
  init();
});

const formatDeleteQrcodeInfo = (row: any) => `您正在进行删除二维码(${row?.name})操作，请谨慎操作`;

const handleDeleteQrcodeAction = useBaseAsync(async(data: QrcodeRow) => {
  if (data.name === '直开') {
    await useApi().storeApi.delDirectQrcodestore({
      storeId: store.value.id,
    });
  } else if (data.name.includes('(小程序)')) {
    await useApi().storeApi.delWeappQrcodestore({
      storeId: store.value.id,
      appid: data.appid,
    });
  } else {
    await useApi().storeApi.delWxQrcodestore({
      storeId: store.value.id,
      h5TplId: data.h5TplId,
    });
  }

  ElMessage.success('删除成功');
  init();
});

const delQrcode = (data: QrcodeRow) => {
  deleteQrcodeDialogRef.value?.showDialog(data as unknown as Record<string, unknown>);
};

const operates: any[] = [
  {
    key: 'saveQrcode',
    name: '下载二维码',
    handler: (row: QrcodeRow, index: number) => saveQrcode(row, index),
  },
  {
    key: 'setDownloadQrcode',
    name: '设置客户端下载',
    handler: (row: QrcodeRow, index: number) => setDownloadQrcode(row, index),
  },
  {
    key: 'delQrcode',
    name: '删除',
    handler: (row: QrcodeRow) => delQrcode(row),
  },
];

__expose({
  show: async(_store: any) => {
    store.value = { ..._store };
    qrcodeDialogVisible.value = true;
    await init();
  },
});


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_HpsfirProTable = _resolveComponent("HpsfirProTable")!
  const _component_HpsfirProDrawer = _resolveComponent("HpsfirProDrawer")!
  const _component_HpsfirProForm = _resolveComponent("HpsfirProForm")!
  const _component_HpsfirProDangerDialog = _resolveComponent("HpsfirProDangerDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HpsfirProDrawer, {
      open: qrcodeDialogVisible.value,
      "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((qrcodeDialogVisible).value = $event)),
      title: `${store.value?.name || ''} （一店一码）`,
      width: "90vw",
      "max-width": "1280px",
      "content-class": "store-qrcode-drawer",
      "body-class": "store-qrcode-drawer__body"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[0] || (_cache[0] = () => addWeappFormRef.value?.showDialog())
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("添加小程序二维码", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[1] || (_cache[1] = () => addH5FormRef.value?.showDialog())
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("添加H5二维码", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = () => _unref(handleAddDirectQrcode)())
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("添加直开二维码", -1)
              ]))]),
              _: 1
            })
          ]),
          (qrcodeDialogVisible.value)
            ? (_openBlock(), _createBlock(_component_HpsfirProTable, {
                key: 0,
                ref_key: "tableRef",
                ref: tableRef,
                "export-file-name": "门店二维码",
                "row-key": "url",
                columns: columns.value,
                "get-data": _unref(getData),
                loading: loading.value,
                operates: operates,
                "operation-width": 380,
                paginations: { pageSize: 10 },
                "hide-add": true,
                "hide-delete": true,
                "hide-edit": true
              }, null, 8, ["columns", "get-data", "loading"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["open", "title"]),
    _createVNode(_component_HpsfirProForm, {
      "is-dialog": true,
      ref_key: "addWeappFormRef",
      ref: addWeappFormRef,
      title: "添加小程序二维码",
      items: addWeappItems.value,
      onOk: _unref(handleaddWeappOk)
    }, null, 8, ["items", "onOk"]),
    _createVNode(_component_HpsfirProForm, {
      "is-dialog": true,
      ref_key: "addH5FormRef",
      ref: addH5FormRef,
      title: "添加H5二维码",
      items: addH5Items.value,
      onOk: _unref(handleaddH5Ok)
    }, null, 8, ["items", "onOk"]),
    _createVNode(_component_HpsfirProDangerDialog, {
      ref_key: "deleteQrcodeDialogRef",
      ref: deleteQrcodeDialogRef,
      title: "删除二维码",
      "opt-name": "删除",
      "on-ok": _unref(handleDeleteQrcodeAction),
      "format-dangder-delete-info": formatDeleteQrcodeInfo
    }, null, 8, ["on-ok"])
  ], 64))
}
}

})